export const PAYMENTS_TYPES = {
  card: 1,
  cashApp: 2,
  cashAppBitcoin: 17
}
